<template>
  <div>
    <Card shadow class="content">
      <div class="main">
        <Alert v-if="error" show-icon type="error">
          获取数据失败
          <a style="float: right;" v-on:click="getAvailabilityZones"><Icon type="md-refresh" size="18" /></a>
        </Alert>
        <div v-else>
          <Row style="margin-bottom: 15px">
            <h4 style="float: left">区域列表</h4>
          </Row>
          <Table
            :loading="tableLoading"
            ref="table"
            :data="availabilityZones"
            :columns="columns">
          </Table>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getPrivateCloudAvailabilityZonesDetailList } from '@/api/private-cloud/availability-zone'

export default {
  name: 'availability-zone',
  data () {
    return {
      error: false,
      availabilityZones: [],
      columns: [
        {
          title: '区域名称',
          key: 'zoneName',
          align: 'center',
          minWidth: 150
        },
        {
          title: '主机',
          key: 'hosts',
          align: 'center',
          minWidth: 200,
          render: (h, params) => {
            let hosts = []
            for (let i in params.row.hosts) {
              let color = 'green'
              let services = params.row.hosts[i]
              let serviceState = []
              for (let s in services) {
                serviceState.push(h('p', {
                  style: {
                    color: services[s].available ? '#19be6b' : '#ff9900'
                  }
                }, `${s}: ${services[s].available ? 'UP' : 'DOWN'}`))
                if (!services[s].available) {
                  color = 'red'
                }
              }
              hosts.push(
                h('Tooltip', [
                  h('Tag', {
                    props: {
                      color: color
                    }
                  }, i),
                  h('div', {
                    slot: 'content'
                  }, serviceState)
                ])
              )
            }
            return h('div', hosts)
          }
        },
        {
          title: '可用',
          key: 'zoneState',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            if (params.row.zoneState && params.row.zoneState.available) {
              return h('Tag', {
                props: {
                  color: 'cyan'
                }
              }, '是')
            } else {
              return h('Tag', {
                props: {
                  color: 'red'
                }
              }, '否')
            }
          }
        }
      ],
      tableLoading: false
    }
  },
  created: function () {
    this.getAvailabilityZones()
  },
  methods: {
    getAvailabilityZones () {
      this.tableLoading = true
      getPrivateCloudAvailabilityZonesDetailList().then(res => {
        this.availabilityZones = res.data
        this.error = false
        this.tableLoading = false
      }).catch(res => {
        this.error = true
        this.tableLoading = false
        console.error(res.response)
      })
    }
  }
}
</script>

<style scoped>

</style>
